<template>
    <div class="uslugi-card">
        <div class="__name __m">{{ item.name.raw }}</div>
        <div class="__description __m">{{ item.description }}</div>
        <div class="__row">
            <div class="__col __photo">
                <div class="img"><img :src="item.img.src" loading="lazy"></div>
            </div>
            <div class="__col __content">
                <div class="__d">
                    <div class="__name">{{ item.name.raw }}</div>
                    <div class="__description">{{ item.description }}</div>
                </div>

                <div class="__aa-wrap">
                    <div v-if="item.about" class="__about-wrap">
                        <div class="__about">
                            <ul>
                                <li v-for="(item2, index2) in item.about.list" :key="index2" v-html="item2"></li>
                            </ul>
                        </div>
                    </div>
                    <div class="__about-footer" v-html="item.about.footer"></div>
                    
                    <div class="__uslugi-wrap">
                        <div class="__uslugi">
                            <div class="__desc-title">{{ item.uslugi.title }}</div>
                            <div class="__header" v-html="item.uslugi.header"></div>
                            <template v-for="(item3, index3) in item.uslugi.list" :key="index3">
                                <template v-if="item3.title">
                                    <ul class="__plus">
                                        <li class="plus" v-html="item3.title"></li>
                                    </ul>
                                    <ul class="__subplus">
                                        <li v-for="(item4, index4) in item3.list" :key="index4" v-html="item4"></li>
                                    </ul>        
                                </template>
                                <template v-else>
                                    <ul class="__plus">
                                        <li class="plus" v-for="(item4, index4) in item3.list" :key="index4" v-html="item4"></li>
                                    </ul>
                                </template>
                            </template>
                            <div class="__footer" v-html="item.uslugi.footer"></div>
                        </div>
                    </div>
                </div>
                <div class="__button">
                    <button @click="()=>{ handleClickButton(item.name.komu) }">Написать спикеру</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UslugiCard',
    emits: [ 'returnKomu' ],
    components: {},
    props: { 
        item: Object,
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        handleClickButton: function(komu) {
            // console.log('komu: ', komu)
            this.$emit('returnKomu', komu )  
        },
    }
}
</script>
<style lang="scss">
$pri: #45289C;
$sec: #1E9BD8;
// $sec: #ffffff;
$text-color: #ffffff;
.uslugi-card{
    background-color: $pri;
    text-align: start;
    border-radius: 10px;
    position: relative;
    padding: 15px 15px 15px 15px;
    background-image: radial-gradient(circle at -27% 40%, #1E9BD8 7%, transparent 58%), radial-gradient(circle at 104% 69%, #290A4F -1%, transparent 67%);

    @media ( min-width: 992px ) {
        padding: 15px 15px 0px 0px;
        background-image: radial-gradient(circle at -3% 4%, #1E9BD8 3%, transparent 48%), radial-gradient(circle at 75% 148%, #290A4F 20%, transparent 73%);
    }
    a{
        color: $text-color;
        transition: .4s;
        &:hover{
            color: $sec;
            transition: .4s;
        }
    }
    .__m{
        display: block;
        @media ( min-width: 992px ){
            display: none;
        }
    }
    .__d{
        display: none;
        @media ( min-width: 992px ){
            display: block;
        }
    }
    .__row{
        display: flex;
        flex-direction: column;
        @media ( min-width: 992px ) {
            flex-direction: row;
        }
        // .__col{}
    }
    .__name{
        color: #fff;
        text-transform: uppercase;
        font-size: 1.5em;
        margin-bottom: 5px;
    }
    .__description{
        color: $text-color;
        text-transform: uppercase;
        margin-bottom: 5px;
        min-height: 20px;
    }

    .__photo{
        display: flex;
        align-items: start;
        .img{
            max-height: fit-content;
            max-width: 450px;
            overflow: hidden;
            border-bottom: solid 1px #00000000;
            border-image: linear-gradient( 90deg, #ffffff00, #1E9BD8, #1E9BD8, #ffffff00);
            border-image-slice: 1;
            padding-left: 5px;
            padding-right: 5px;
            img{
                border-radius: 10px;
                width: 100%;
                height: auto;
                object-fit: contain;
            }
        }

    }

    .__about-wrap{
        position: relative;
        border: solid 1px #1E9BD8;
        padding: 16px;
        border-radius: 10px;
        margin-bottom: 1em;
        &::before{
            content: '“';
            color: #1E9BD8;
            font-size: 80px;
            position: absolute;
            top: -25px;
            right: 19px;
            display: block;
            height: 0px;
            width: 0px;
        }
        ul{
            margin: 0;
            padding: 0 14px;
            font-size: .9em;
        }
    }
    .__uslugi-wrap{
        margin-bottom: 75px;
        .__desc-title{
            text-transform: uppercase;
            margin-bottom: 15px;
            color: #fff;
            // color: $sec;
        }
        ul.__plus{
            padding-left: 24px;
        }
        ul.__subplus{
            border: solid 1px $sec;
            border-radius: 10px;
            padding: 14px 14px 14px 34px;
            font-size: .9em;
        }
    }
    .__about-wrap, .__uslugi-wrap{
        color: $text-color;
        li{
            color: $text-color;
        }
        // color: $sec;
    }
    .__about-footer{
        color: $text-color;
        ul{
            border: solid 1px $sec;
            border-radius: 10px;
            padding: 14px 14px 14px 34px;
            font-size: .9em;
        }
    }
    .__button{
        text-align: end;
        margin-top: 10px;
        margin-bottom: 10px;
        button{
            position: absolute;
            right: 15px;
            bottom: 15px;
            background: #1E9BD8;
            color: #FFF;
            border-radius: 50px;
            border: solid 1px #1E9BD8;
            padding: 10px 24px;
            font-size: .9em;
            // text-transform: capitalize;
        }
    }
}
</style>